import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';
import store from '@/store'

import Tickets from '@/views/support/Tickets';
import Ticket from '@/views/support/Ticket';

export default {
  path: 'support',
  component: Tickets,
  name: 'support-tickets',
  meta: { title: 'Support Tickets' },
  children : [
    {
      path: 'ticket/:ticketId',
      component: Ticket,
      meta: { title: 'Ticket' },
      name : 'ticket-by-id',
    },
  ]
}
